// extracted by mini-css-extract-plugin
export default {"fixed-width":"_-web-client-js-react-components-___WTFPrincipalField-module__fixed-width___hi1iT"};